<template>
  <v-dialog :value="showModal" max-width="600px" @input="updateShowModal">
    <v-card>
      <v-card-text>
        <slot />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="#FF0000" style="color: white" @click="closeModal">
          Cerrar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'NotificationModalContainer',
    props: {
      showModal: Boolean,
    },
    methods: {
      updateShowModal(value) {
        this.$emit('update:showModal', value);
      },
      closeModal() {
        this.$emit('closeModal');
      },
    },
  };
</script>
